var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imofalform5FormHeader puiformheader"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('pui-field',{attrs:{"label":_vm.$t('header.imofalform5.familyname'),"value":_vm.getFamilynameValue}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }